import { BlockType } from './Block';
import {
    mdiBrain,
    mdiContentCut,
    mdiDraw,
    mdiFormDropdown,
    mdiMessageImage,
    mdiMessageProcessing,
    mdiMessageQuestion,
    mdiMessageReplyText,
    mdiMessageVideo,
    mdiStickerCheck,
    mdiStickerEmoji,
    mdiStickerText,
    mdiImageFrame,
    mdiFormatListChecks,
    mdiFormTextbox,
    mdiTimer,
    mdiWeb,
    mdiMicrophone,
} from '@mdi/js';

import ChatTextBlock from './Blocks/ChatTextBlock/ChatTextBlock';
import NPOPlayerBlock from './Blocks/NPOPlayerBlock/NPOPlayerBlock';
import EditorNoteBlock from './Blocks/EditorNote/EditorNote';
import ChatImageBlock from './Blocks/ChatImageBlock/ChatImageBlock';
import ChatAudioBlock from './Blocks/ChatAudioBlock/ChatAudioBlock';
import ChatStickerBlock from './Blocks/ChatStickerBlock/ChatStickerBlock';
import PollBlock from './Blocks/PollBlock/PollBlock';
import QuizBlock from './Blocks/QuizBlock/QuizBlock';
import ClassifyImageBlock from './Blocks/ClassifyImageBlock/ClassifyImageBlock';
import MissingWordBlock from './Blocks/MissingWordBlock/MissingWordBlock';
import SketchAIBlock from './Blocks/SketchAIBlock/SketchAIBlock';
import RPSAIBlock from './Blocks/RPSAIBlock/RPSAIBlock';
import PhotoFrameBlock from './Blocks/PhotoFrameBlock/PhotoFrameBlock';
import ChecklistBlock from './Blocks/ChecklistBlock/ChecklistBlock';
import OpenQuestionBlock from './Blocks/OpenQuestionBlock/OpenQuestionBlock';
import CountdownBlock from './Blocks/CountDownBlock/CountdownBlock';
import EmbedBlock from './Blocks/EmbedBlock/EmbedBlock';
import MediaMachineMiniBlock from './Blocks/MediaMachineBlock/MediaMachineBlock';

export enum BlockTransitionType {
    INSTANT,
    AUTOMATIC,
    INTERACTIVE,
    SKIPPED,
}

export const BlockTransitionTypeDisplayNames = {
    [BlockTransitionType.INSTANT]: 'Samen met interactie',
    [BlockTransitionType.AUTOMATIC]: 'Automatische transitie',
    [BlockTransitionType.INTERACTIVE]: 'Interactieve transitie',
    [BlockTransitionType.SKIPPED]: 'Overgeslagen',
} as const;

export const BLOCK_TYPES: Record<string, BlockType> = {
    chat_text: {
        type: 'chat_text',
        displayName: 'Chatberichtje',
        icon: mdiMessageProcessing,
        transitionType: BlockTransitionType.AUTOMATIC,
        component: ChatTextBlock,
        isEditorOnly: false,
    },
    chat_image: {
        type: 'chat_image',
        displayName: 'Chat afbeelding',
        icon: mdiMessageImage,
        transitionType: BlockTransitionType.AUTOMATIC,
        component: ChatImageBlock,
        isEditorOnly: false,
    },
    chat_sticker: {
        type: 'chat_sticker',
        displayName: 'Chat sticker',
        icon: mdiStickerEmoji,
        transitionType: BlockTransitionType.AUTOMATIC,
        component: ChatStickerBlock,
        isEditorOnly: false,
    },
    chat_audio: {
        type: 'chat_audio',
        displayName: 'Chat audio',
        icon: mdiMicrophone,
        transitionType: BlockTransitionType.INTERACTIVE,
        component: ChatAudioBlock,
        isEditorOnly: false,
    },
    npo_player: {
        type: 'npo_player',
        displayName: 'NPO Player',
        icon: mdiMessageVideo,
        transitionType: BlockTransitionType.INTERACTIVE,
        component: NPOPlayerBlock,
        isEditorOnly: false,
    },
    poll: {
        type: 'poll',
        displayName: 'Poll',
        icon: mdiMessageReplyText,
        transitionType: BlockTransitionType.INTERACTIVE,
        component: PollBlock,
        isEditorOnly: false,
    },
    quiz: {
        type: 'quiz',
        displayName: 'Quiz',
        icon: mdiMessageQuestion,
        transitionType: BlockTransitionType.INTERACTIVE,
        component: QuizBlock,
        isEditorOnly: false,
    },
    classify_image: {
        type: 'classify_image',
        displayName: 'Classificeren',
        icon: mdiStickerCheck,
        transitionType: BlockTransitionType.INTERACTIVE,
        component: ClassifyImageBlock,
        isEditorOnly: false,
    },
    missing_word: {
        type: 'missing_word',
        displayName: 'Ontbrekend woord',
        icon: mdiFormDropdown,
        transitionType: BlockTransitionType.INTERACTIVE,
        component: MissingWordBlock,
        isEditorOnly: false,
    },
    checklist: {
        type: 'checklist',
        displayName: 'Checklist',
        icon: mdiFormatListChecks,
        transitionType: BlockTransitionType.INTERACTIVE,
        component: ChecklistBlock,
        isEditorOnly: false,
    },
    photo_frame: {
        type: 'photo_frame',
        displayName: 'Fotolijst',
        icon: mdiImageFrame,
        transitionType: BlockTransitionType.INTERACTIVE,
        component: PhotoFrameBlock,
        isEditorOnly: false,
    },
    open_question: {
        type: 'open_question',
        displayName: 'Open vraag',
        icon: mdiFormTextbox,
        transitionType: BlockTransitionType.INTERACTIVE,
        component: OpenQuestionBlock,
        isEditorOnly: false,
    },
    countdown: {
        type: 'countdown',
        displayName: 'Timer',
        icon: mdiTimer,
        transitionType: BlockTransitionType.INTERACTIVE,
        component: CountdownBlock,
        isEditorOnly: false,
    },
    embed: {
        type: 'embed',
        displayName: 'Insluiting',
        icon: mdiWeb,
        transitionType: BlockTransitionType.INTERACTIVE,
        component: EmbedBlock,
        isEditorOnly: false,
    },
    sketch_ai: {
        type: 'sketch_ai',
        displayName: 'Teken AI',
        icon: mdiDraw,
        transitionType: BlockTransitionType.INTERACTIVE,
        component: SketchAIBlock,
        isEditorOnly: false,
    },
    rps_ai: {
        type: 'rps_ai',
        displayName: 'Steen papier schaar',
        icon: mdiContentCut,
        transitionType: BlockTransitionType.INTERACTIVE,
        component: RPSAIBlock,
        isEditorOnly: false,
    },
    media_machine: {
        type: 'media_machine',
        displayName: 'Media Machine',
        icon: mdiBrain,
        transitionType: BlockTransitionType.INTERACTIVE,
        component: MediaMachineMiniBlock,
        isEditorOnly: false,
    },
    editor_note: {
        type: 'editor_note',
        displayName: 'Redactie notitie',
        icon: mdiStickerText,
        transitionType: BlockTransitionType.INSTANT,
        component: EditorNoteBlock,
        isEditorOnly: true,
    },
};
